import { Injectable } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';

import { DbsSpinnerService } from '@careconne/core/services/common';

@Injectable({
  providedIn: 'root',
})
export class MultipleSpinnerService {
  private countLoading = 0;

  constructor(
    private readonly dbsSpinnerService: DbsSpinnerService,
    private readonly router: Router,
  ) {}

  show(options?: { fullWhite?: boolean }) {
    this.countLoading++;
    this.dbsSpinnerService.show(options);
  }

  hide() {
    this.countLoading--;
    if (this.countLoading === 0) {
      this.dbsSpinnerService.hide();
    } else if (this.countLoading < 0) {
      this.countLoading++;
      console.warn('countLoading cannot be less than 0');
    }
  }

  hideBeforeNavigate() {
    this.countLoading = 0;
    this.dbsSpinnerService.hide();
  }

  trackRouteLoadIndicator() {
    this.router.events.subscribe((event): void => {
      if (event instanceof RouteConfigLoadStart) {
        this.show();
      } else if (event instanceof RouteConfigLoadEnd) {
        this.hideBeforeNavigate();
      }
    });
  }
}
